import { render, staticRenderFns } from "./AsiAvatar.vue?vue&type=template&id=d9cdb996&scoped=true"
import script from "./AsiAvatar.vue?vue&type=script&lang=ts"
export * from "./AsiAvatar.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d9cdb996",
  null
  
)

export default component.exports